export const PREFILLABLE_COMPONENT_TYPES = new Set([
    'singleText',
    'textBox',
    'numericInputBox',
    'checkboxQuestion',
    'employeeSelect',
    'dateTime',
    'date',
    'offerStatusChoice',
    'address',
    'upn',
    'previousSchoolName',
    'previousSchoolEmail'
]);

export const TEXT_COMPONENT_TYPES = new Set([
    'singleText',
    'textBox'
]);

export const SEVERAL_ANSWER_COMPONENT_TYPES = new Set([
    'tickBoxGrid',
    'multipleChoiceGrid',
    'questionGrid',
    'multiLineInput',
    'address',
    'employeeSelect',
    'lookupDropdown'
]);

export const ANSWER_SOURCE_COMPONENT_TYPES = new Set([
    'singleText',
    'textBox',
    'numericInputBox',
    'checkboxQuestion',
    'dateTime',
    'date',
    'linearScale',
    'dropdown',
    'singleChoice',
    'multipleChoice',
    'intakeChoice',
    'boarderStatusChoice',
    'admissionCategories',
    'offerStatusChoice',
    'upn',
    'previousSchoolName',
    'previousSchoolEmail'
]);

export const canPrefillFrom = (targetType, sourceType, targetInputType) => {
    if (!targetType || !sourceType) {
        return false;
    }

    if (targetType === sourceType) {
        return true;
    }

    if (!TEXT_COMPONENT_TYPES.has(targetType)) {
        return false;
    }

    if (targetInputType && targetInputType !== 'text') {
        return false;
    }

    return ANSWER_SOURCE_COMPONENT_TYPES.has(sourceType) && !SEVERAL_ANSWER_COMPONENT_TYPES.has(sourceType);
};
